export default "<admin-permission \n[id]=\"data.id\"\n[dynamic]=\"data.id\"\n[type]=\"data.type\">\n</admin-permission>\n\n"